import { useEffect, useState } from "react"
import DealershipEnquiry from "@/components/DealershipEnquiry/Form/DealershipEnquiry"
import Confirmation from "@/components/DealershipEnquiry/Confirmation"
import styles from "@/components/DealershipEnquiry/DealershipEnquiryView/index.module.scss"
import useDealershipEnquiry from "@/i18n/useDealershipEnquiryi18n"

const DealershipEnquiryView = props => {
  const { data, citiesData } = props
  const authorData = { ...data, cities: citiesData }
  const staticText = useDealershipEnquiry(authorData)

  const [confirmationSuccess, setConfirmationSuccess] = useState(false)
  useEffect(() => {
    const scrollToTop = () => {
      window.scroll({
        top: 0,
        behavior: "smooth",
      })
    }
    scrollToTop()
  }, [confirmationSuccess])
  return (
    <div className={styles.dealershipEnquiry}>
      <div className="dealership-enquiry">
        {!confirmationSuccess && (
          <DealershipEnquiry
            staticText={staticText}
            setConfirmationSuccess={setConfirmationSuccess}
          />
        )}
        {confirmationSuccess && <Confirmation staticText={staticText} />}
      </div>
    </div>
  )
}

export default DealershipEnquiryView
